<template>
  <label
    :class="[
      ns.b(segment ? 'segment' : 'button'),
      ns.is('active', modelValue === value),
      ns.is('disabled', disabled),
      ns.is('focus', focus),
      ns.bm(segment ? 'segment' : 'button', size),
      ns.is('vertical', radioGroup?.vertical),
    ]"
    data-test-name="radio-button"
    data-test-variant=""
    data-test-state=""
  >
    <input
      ref="radioRef"
      v-model="modelValue"
      :class="ns.be(segment ? 'segment' : 'button', 'original-radio')"
      :value="value"
      type="radio"
      :name="name || radioGroup?.name"
      :disabled="disabled"
      @focus="focus = true"
      @blur="focus = false"
    />

    <span :class="ns.be(segment ? 'segment' : 'button', 'inner')" @keydown.stop>
      <b-icon v-if="Boolean(icon)" :size="(large && 24) || (small && 16) || 20">
        <Component :is="icon" />
      </b-icon>
      <span>
        <slot>
          {{ label }}
        </slot>
      </span>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { useNamespace } from '@bigin/hooks'
import BIcon from '@bigin/components/icon'
import { useRadio } from './use-radio'
import { radioButtonProps } from './radio-button'

defineOptions({
  name: 'BRadioButton',
})

const props = defineProps(radioButtonProps)

const ns = useNamespace('radio')
const { radioRef, focus, size, disabled, modelValue, radioGroup, segment } =
  useRadio(props)
</script>
